export enum RedirectToPortalDestination {
  GenerateCampaignStatement,
  RequestCancellation,
  EditCampaignDetails
}
